import React from 'react'
import Footer from './footer';

export default function Contact() {
    const headerStyle = {
        backgroundColor: '#333',
        color: '#fff',
        textAlign: 'center',
        padding: '1em',
    };

    const mainStyle = {
        maxWidth: '600px',
        margin: '20px auto',
        padding: '20px',
        backgroundColor: '#fff',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
    };

    const formStyle = {
        display: 'grid',
        gap: '15px',
    };

    const labelStyle = {
        fontWeight: 'bold',
    };

    const inputStyle = {
        width: '100%',
        padding: '10px',
        boxSizing: 'border-box',
        border: '1px solid #ccc',
        borderRadius: '4px',
    };

    const textareaStyle = {
        width: '100%',
        padding: '10px',
        boxSizing: 'border-box',
        border: '1px solid #ccc',
        borderRadius: '4px',
    };

    const buttonStyle = {
        backgroundColor: '#333',
        color: '#fff',
        padding: '10px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
    };

    const footerStyle = {
        backgroundColor: '#333',
        color: '#fff',
        textAlign: 'center',
        padding: '1em',
    };
    return (
        <>
            <div className="container">
                <h1 style={{ textAlign: 'center', fontFamily: 'Times New Roman' }}>Web Blog</h1>
                <p style={{ textAlign: 'center' }}>Your go-to destination for all things web development</p>
                <main style={mainStyle}>
                    <form style={formStyle}>
                        <label style={labelStyle} htmlFor="name">Name:</label>
                        <input style={inputStyle} type="text" id="name" name="name" required />

                        <label style={labelStyle} htmlFor="email">Email:</label>
                        <input style={inputStyle} type="email" id="email" name="email" required />

                        <label style={labelStyle} htmlFor="message">Message:</label>
                        <textarea style={textareaStyle} id="message" name="message" rows="4" required></textarea>

                        <button style={buttonStyle} type="submit">Submit</button>
                    </form>
                </main><br />
                <div className="btn-x">
                    <a href="/">
                        <button className='btn btn-primary'>Home</button>
                    </a>
                </div>
            </div>
            <br />
            <Footer />
        </>
    )
}